module.exports = __webpack_public_path__ + "static/media/arrow_right_white_24dp.d2cf3da7.svg";